import React, { Component, useState } from "react";
import { Alert } from "reactstrap";
import * as Columns from "./Columns.js";
import * as TabColumns from "./TabColumns.js";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TableKey from "./Key";
import Container from "react-bootstrap/Container";
import OrderTable from "./OrderTable";
import "./style.css";
import FormControl from "react-bootstrap/FormControl";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
// use Theme(s)
import "react-tabulator/css/tabulator_modern.min.css";

// for React 16.4.x use: import { ReactTabulator } - example in github repo.
import { React15Tabulator, reactFormatter } from "react-tabulator"; // for React 15.x
import { msalAuth } from "../msal/MsalAuthProvider";
import { getUserDetails } from "../graph/GraphService";
export class EngOrder extends Component {

	static displayName = "IMATs Ordering";

	constructor(props) {
		super(props);
		this.tableRef = React.createRef();
		this.state = {
			equipment: [],
			loading: true,
			readyForReview: false,
			unpicked: [],
			columns: [],
			tableWidth: 0,
			job: "",
			branchName: "Engineering",
			useUkList: false,
			currency: "$",
		};

		this.reviewOrder = this.reviewOrder.bind(this);
		this.continueOrder = this.continueOrder.bind(this);
		this.submitOrder = this.submitOrder.bind(this);
		this.download = this.download.bind(this);
		this.exportCSVFile = this.exportCSVFile.bind(this);
		this.convertToCSV = this.convertToCSV.bind(this);
		this.setJobName = this.setJobName.bind(this);
		this.onAddRow = this.onAddRow.bind(this);
		this.dataChangedCheck = this.dataChangedCheck.bind(this);
		this.checkSelectability = this.checkSelectability.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.renderReviewTable = this.renderReviewTable.bind(this);
		this.toggleUkList = this.toggleUkList.bind(this);
	}

	async componentDidMount() {
		const {
			match: { params },
		} = this.props;

		var branchName = params.branchId;

		// Load equipment data immediately - this calls the .NET backend which handles
		// its own SharePoint auth, so it does not need to wait for the Graph token
		this.EquipmentData(branchName);

		this.setState({
			columns: TabColumns.tabEngColumns,
			branch: branchName,
		});
	}

	rowClick = (e, row) => {
		console.log("ref table: ", this.ref.table); // this is the Tabulator table instance
		console.log(`rowClick id: \${row.getData().id}`, row, e);
		this.setState({ selectedName: row.getData().name });
	};

	setData = () => {
		this.setState(this.state.equipment);
	};
	onAddRow() {
		this.tableRef.current.table.addRow({ description: "", importantNotes: "", name: "", notes: "", newPartNumber: "", oldPartNumber: "", quantity: "", typeOfEquipment: "", unitOfMeasure: "", url: null, vendor: "", cost: 0, quantity: 0 }, true); //true adds to top
	};
	deleteRow() {

	}
	reviewOrder() {
		console.log("we are reviewing the order now");

		const {
			match: { params },
		} = this.props;
		var branchName = params.branchId;
		if (branchName === "Job" && this.state.notes == "") {
			alert("Please input job information to continue your order");
			return;
		}
		this.setState({
			readyForReview: true,
			equipment: this.state.equipment.filter(function (item) {
				return item.quantity > 0;
			}),
			unpicked: this.state.equipment.filter(function (item) {
				return item.quantity == 0;
			}),
		});
	}
	continueOrder() {

		let data = this.state.equipment.concat(this.state.unpicked);

		let sorted = []
			.concat(data)
			.sort((a, b) => (a.typeOfEquipment > b.typeOfEquipment ? 1 : -1));

		this.setState({
			equipment: sorted,
			readyForReview: false,
			unpicked: [],
		});
	}
	setJobName() {
		let value = document.getElementById("jobNumber").value;
		this.setState(
			{
				job: value,
			},
			() => {

			}
		);
	}

	dataChangedCheck(data) {

		this.setState({
			equipment: data,
		});

		console.table(this.state.equipment);
	}
	checkSelectability(row) {
		console.log("Selected")
		if (this.state.readyForReview) {

			return true;
		}
		return false;
	}
	renderOrderTable(equipment) {
		return (
			<>
				<div>
					<React15Tabulator
						ref={this.tableRef}
						columns={this.state.columns}
						data={this.state.equipment}
						footerElement={<span>CTI Imaterials</span>}
						height={"500px"}
						selectable={false}
						layout={"fitColumns"}
					//row - row component

					/>
				</div>
			</>
		);
	}
	renderReviewTable() {
		return (
			<>
				<div>
					<React15Tabulator
						ref={this.tableRef}
						columns={this.state.columns}
						data={this.state.equipment}
						footerElement={<span>CTI Imaterials</span>}
						height={"500px"}
						dataChanged={this.dataChangedCheck}
						layout={"fitColumns"}
					/>
				</div>
			</>
		);
	}


	render() {
		const {
			match: { params },
		} = this.props;


		let branchName = params.branchId;
		let header = this.state.branch == "" ? branchName : this.state.branch;
		let contents = this.state.loading ? (<p><em>Loading...</em>	</p>) : !this.state.readyForReview ? (this.renderOrderTable(this.state.equipment)) : this.renderReviewTable();


		if (!this.state.readyForReview) {
			var label = "";
			if (this.state.branch == "Job") {
				label = "Input Job Number and notes.  Information added will be sent to purchasing.";
			}

			return (
				<>
					<Container>
						<h1 style={{ width: "25%" }}>Engineering Order</h1>

						<div style={{ marginBottom: "10px" }}>
							<button
								className={`btn ${this.state.useUkList ? "btn-secondary" : "btn-outline-secondary"}`}
								onClick={this.toggleUkList}
								style={{ marginRight: "8px" }}
							>
								{this.state.useUkList ? "🇬🇧 UK List" : "🇺🇸 US List"}
							</button>
						</div>

						<InputGroup className="mb-3" style={{ width: '70%', margin: '0 auto' }}>
							<FormControl
								id="jobNumber"
								placeholder="Job Information"
								aria-label="Notes"
								aria-describedby="basic-addon2"
							/>
							<InputGroup.Append>
								<Button
									onClick={this.setJobName}
									variant="outline-secondary"
								>
									Submit
								</Button>
							</InputGroup.Append>
						</InputGroup>
						<h5>
							Job Info: {this.state.job}
						</h5>

						<label>
							{label}
						</label>


						<TableKey style={{ marginTop: '15px;' }} />
						{contents}
						<div>

							<button className="btn btn-primary" onClick={this.reviewOrder}>
								Review Order
							</button>
						</div>
					</Container>
				</>
			);
		}

		if (this.state.readyForReview) {
			return (
				<div>
					<h1>{branchName} Review Order</h1>
					{contents}

					<button className="btn btn-primary" id="add-row" onClick={this.onAddRow}>Add Row</button>

					<button className="btn btn-primary" onClick={this.continueOrder}>
						Continue Order
					</button>

					<button style={{ margin: "5px" }} className="btn btn-primary" onClick={this.submitOrder}>
						Sign Off
					</button>
				</div>
			);
		}
	}

	//put these all in a button component
	//pass in equipment state and do everything in that component
	submitOrder() {
		/*console.table(this.state.equipment);*/
		this.download();
	}
	convertToCSV(objArray) {
		var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
		var str = "";

		for (var i = 0; i < array.length; i++) {
			var line = "";
			for (var index in array[i]) {
				if (line != "") line += ",";

				line += array[i][index];
			}

			str += line + "\r\n";
		}

		return str;
	}
	exportCSVFile(headers, items, fileTitle) {
		if (this.state.branch != "Engineering") {
			alert("Your file is now downloading.  Check your downloads folder for your order.");
		}
		if (headers) {
			items.unshift(headers);
		}

		// Convert Object to JSON
		var jsonObject = JSON.stringify(items);

		var csv = this.convertToCSV(jsonObject);

		var exportedFilenmae = fileTitle + ".csv" || "export.csv";

		var blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
		if (navigator.msSaveBlob) {
			// IE 10+

			navigator.msSaveBlob(blob, exportedFilenmae);
		} else {
			var link = document.createElement("a");
			if (link.download !== undefined) {
				// feature detection
				// Browsers that support HTML5 download attribute

				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", exportedFilenmae);
				link.style.visibility = "hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);


			}
		}
	}
	download() {

		const {
			match: { params },
		} = this.props;
		var branchName = params.branchId;
		var itemsNotFormatted = this.state.equipment;
		var itemsFormatted = [];



		// format the data




		var headers = {
			vendor: "Vendor",
			newPartNumber: "Part Number",
			description: "Description".toString().replace(/,/g, ""), // remove commas to avoid errors
			cost: "Cost Per",
			unitOfMeasure: "Measure",
			quantity: "Quantity",
			itemCost: "Item Cost",
		};

		var totalCost = 0;

		itemsNotFormatted.forEach((item) => {
			let itemCost = item.quantity * item.cost;
			totalCost = totalCost + itemCost;
			//doing some really stupid shit to spoof a footer
		});
		let totalSlop = totalCost + (totalCost * .05);


		itemsNotFormatted.forEach((item) => {
			let itemCost = item.quantity * item.cost;

			itemsFormatted.push({
				vendor: item.vendor,
				newPartNumber: '="' + item.newPartNumber.toString().replace(/,/g, "") + '"',
				description: item.description.toString().replace(/,/g, ""), // remove commas to avoid errors,
				cost: this.state.currency + Number(item.cost).toFixed(2),
				unitOfMeasure: item.unitOfMeasure?.toString().replace(/,/g, "") || "",
				quantity: item.quantity?.toString().replace(/,/g, ""),
				itemCost: this.state.currency + Number(itemCost).toFixed(2),
			});
		});

		itemsFormatted.push({
			vendor: " ",
			newPartNumber: " ",
			description: " ",
			cost: " ",
			unitOfMeasure: "Total: ",
			quantity: " ",
			itemCost: this.state.currency + Number(totalCost).toFixed(2),
		})
		itemsFormatted.push({
			vendor: " ",
			newPartNumber: " ",
			description: " ",
			cost: " ",
			unitOfMeasure: "Signoff Total: ",
			quantity: " ",
			itemCost: this.state.currency + Number(totalSlop).toFixed(2),
		})


		var today = new Date();
		var date =
			+(today.getMonth() + 1) +
			"-" +
			today.getDate() +
			"-" +
			today.getFullYear();



		var fileTitle = this.state.job + "_Order" + "_" + date; // or 'my-unique-title'


		this.exportCSVFile(headers, itemsFormatted, fileTitle); // call the exportCSVFile() function to process the JSON and trigger the download
	}

	async EquipmentData(branchName) {
		const url = branchName === "LON"
			? "equipment?branch=LON"
			: "equipment";
		const response = await fetch(url);
		var data = await response.json();
		console.log(data);
		this.setState({ equipment: data, loading: false });
	}

	toggleUkList() {
		const useUkList = !this.state.useUkList;
		const currency = useUkList ? "£" : "$";
		const columns = useUkList
			? TabColumns.tabLonColumns
			: TabColumns.tabEngColumns;
		this.setState(
			{ useUkList, currency, columns, equipment: [], loading: true },
			() => {
				this.EquipmentData(useUkList ? "LON" : null);
			}
		);
	}

}
